import { render, staticRenderFns } from "./vt-horizontal-list.vue?vue&type=template&id=23b21fed&scoped=true&"
import script from "./vt-horizontal-list.vue?vue&type=script&lang=ts&"
export * from "./vt-horizontal-list.vue?vue&type=script&lang=ts&"
import style0 from "./vt-horizontal-list.vue?vue&type=style&index=0&id=23b21fed&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b21fed",
  null
  
)

export default component.exports